import { Logger } from "../core/Logger";
import { WidgetType, type Config, type ContentContainer, type Options } from "../core/types";
import type { BaseWidget } from "./BaseWidget";
import { BannerWidget } from "./BannerWidget";
import { CtaWidget } from "./CtaWidget";
import { EmbedWidget } from "./EmbedWidget";
import type { IIframeProvider } from "../modal/IframeProvider";
import type { ITrackingService } from "../tracking/ITrackingService";

export class WidgetFactory {


    public static create(
        container: ContentContainer,
        dealerKey: string,
        config: Config,
        iframeProvider: IIframeProvider,
        tracker: ITrackingService,
        options: Options,
        trackerId: string
    ): BaseWidget {
        switch (container.widgetType) {
            case WidgetType.CTA:
                return new CtaWidget(container, dealerKey, config, tracker, iframeProvider, options, trackerId);
            case WidgetType.BANNER:
                return new BannerWidget(container, dealerKey, config, tracker, iframeProvider, options, trackerId);
            case WidgetType.EMBED:
                return new EmbedWidget(container, dealerKey, config, tracker, iframeProvider, options, trackerId);
            default:
                Logger.warn(`Unknown widget type: ${container.widgetType}`, container.element);
                throw new Error(`Unknown widget type: ${container.widgetType}`);
        }
    }
}